import * as AuthSession from 'expo-auth-session';
import { AUTH_REDIRECT_PATH, AUTH_REDIRECT_SCHEME } from './auth.constants';
import { AuthTokens } from './auth.types';

/**
 * Builds the in-memory token payload.
 */
export function buildTokenPayload(
  tokenResponse: AuthSession.TokenResponse,
  fallbackRefreshToken?: string,
): AuthTokens {
  const expiresAt = tokenResponse.expiresIn
    ? Date.now() + tokenResponse.expiresIn * 1000
    : undefined;

  return {
    accessToken: tokenResponse.accessToken,
    idToken: tokenResponse.idToken,
    refreshToken: tokenResponse.refreshToken ?? fallbackRefreshToken,
    expiresAt,
    tokenType: tokenResponse.tokenType,
    scope: tokenResponse.scope,
  };
}

/**
 * Computes the correct redirect URI depending on platform & environment.
 */
export function getRedirectUri(isWeb: boolean): string {
  if (isWeb) {
    return AuthSession.makeRedirectUri({ preferLocalhost: true });
  }

  if (__DEV__) {
    return AuthSession.getDefaultReturnUrl();
  }

  return AuthSession.makeRedirectUri({
    scheme: AUTH_REDIRECT_SCHEME,
    path: AUTH_REDIRECT_PATH,
  });
}
